/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Tagindex_Title1Inputs */

const en_seo_tagindex_title1 = /** @type {(inputs: Seo_Tagindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const zh_seo_tagindex_title1 = /** @type {(inputs: Seo_Tagindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部标签`)
};

/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Seo_Tagindex_Title1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_tagindex_title1 = /** @type {((inputs?: Seo_Tagindex_Title1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Tagindex_Title1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_tagindex_title1(inputs)
	return zh_seo_tagindex_title1(inputs)
});
export { seo_tagindex_title1 as "seo.tagIndex.title" }